import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PlanSubdirectoryTableItem from './PlanSubdirectoryTableItem';
import {
  ISubdirectoryQueryData,
  ISubdirectoryVars,
  useSubdirectoryQuery,
} from '../../../../../graphql/query/subdirectory/useSubdirectoryQuery';
import GraphQLTable from '../../../../components/_table/GraphQLTable';
import Helmet from '../../../../components/Helmet';
import { ISubdirectorySchema } from '../../../../../graphql/type/subdirectory';
import PlanLayout from '../../../../layout/Plan';
import { IProductQueryDropshippingProductRequestsParameter } from '../../../../../graphql/query/product/subqueryParameter/productQueryDropshippingProductRequestParameter';
import Context from '../../../../context';
import { ISubdirectoryQueryCompanySubdirectorySubscriptionParameter } from '../../../../../graphql/query/subdirectory/subqueryParameter/subdirectoryQueryCompanySubdirectorySubscriptionParameter';

function PlanSubdirectoryTable() {
  const { t } = useTranslation();
  const [tableRefreshKey, setTableRefreshKey] = useState<number>(0);
  const [selectedItems, setSelectedItems] = useState<ISubdirectorySchema[]>([]);
  const { company: contextCompany } = useContext(Context);

  const companySubdirectorySubscriptionCompanyId: ISubdirectoryQueryCompanySubdirectorySubscriptionParameter['companyId'] =
    contextCompany._id;

  return (
    <>
      <Helmet title={`${t('subdirectory', { count: 2 })} | ${t('plan')}`} />
      <GraphQLTable<
        ISubdirectoryQueryData,
        ISubdirectorySchema,
        ISubdirectoryVars
      >
        refreshKey={tableRefreshKey}
        select={`
				_id
				company
				companyData {
                  _id
                  name {
                      la
                      text
                  }
                  origin
                  slug
                }
                companySubdirectorySubscriptionData(companyId: "${companySubdirectorySubscriptionCompanyId}") {
                  _id
                  status
                  expiryDate
                }
				status
                domain
       	 `}
        useQuery={useSubdirectoryQuery}
        renderHeader={[
          {
            field: '_id',
            label: t('id'),
            align: 'left',
            sortable: true,
          },
          {
            field: 'domain',
            label: t('domain'),
            align: 'center',
          },
          {
            field: 'company',
            label: t('company'),
            align: 'center',
          },
          {
            field: 'status',
            label: t('status'),
            align: 'center',
          },
          {
            field: 'action',
            label: t('action'),
            align: 'right',
          },
        ]}
        renderItem={(item) => (
          <PlanSubdirectoryTableItem
            item={item}
            setTableRefreshKey={setTableRefreshKey}
          />
        )}
        onItemSelected={setSelectedItems}
        selectedItems={selectedItems}
        searchFields={{
          _id: { label: t('id') },
          domain: { label: t('domain') },
        }}
        title={`${t('subdirectory')} ${t('list')}`}
        defaultFilterOptions={{
          status: true,
        }}
        defaultSort="createdTime"
        defaultSortOrder={-1}
        actionButtons={[]}
        itemKey="_id"
      />
    </>
  );
}

export default () => <PlanLayout main={<PlanSubdirectoryTable />} />;
